{
  "Login": {
    "Title": "영수증 저장하기 위해 로그인하세요.",
    "GoogleButton": "Google 아이디로 로그인",
    "FacebookButton": "페이스북 아이디로 로그인",
    "KakaoButton": "카카오 아이디로 로그인",
    "NaverButton": "네이버 아이디로 로그인",
    "OR": "또는",
    "LineButton": "LINE으로 로그인",
    "MobileNumber": "전화 번호",
    "Continue": "전화번호로 로그인",
    "EndUserLicenseAgreement": "최종 사용자 라이선스 계약",
    "PrivacyPolicy": "개인정보보호정책",
    "EulaAndPrivacyPolicyTerm": "로그인함으로서 귀하는 당사의 \n{eula}과 {privacyPolicy}에 동의합니다",
    "OtherLoginMethods": "다른 로그인 방법",
    "SelectCountry": "국가 또는 위치를 선택해 주세요",
    "EncourageSocialLogin": "For a faster and more secure experience, \n{signInText}",
    "EncourageSocialLogin2": "sign in via Social Login"
  },
  "BottomNavbar": {
    "Receipts": "영수증",
    "Account": "계정"
  },
  "PhoneVerification": {
    "Title": "핸드폰 인증",
    "EnterCode": "코드 입력",
    "SMSDiscription": "SMS 본인인증 번호를 전송했습니다.",
    "InvalidOtp": "무효한 코드입니다.",
    "TryAgainInfo": "다시 입력하세요.",
    "OTPExpireTime": "The OTP code will expire in ",
    "OTPNotArrive": "Haven't receive the code?",
    "Resend": "Resend OTP",
    "ChangePhone": "Change Phone Number",
    "ResendToast": "We've sent a new 6-digit OTP code to your phone."
  },
  "ReceiptLoader": {
    "PleaseWait": "Please wait...",
    "TakingLongerText": "잠시만 기다려주세요...",
    "NotifyText2": "영수증이 준비 됐을 때 알림이 도착할 것입니다.",
    "OKButton": "확인",
    "LoginButton": "로그인",
    "NotifyMeButton": "알림 받기",
    "ReceiptWait": "거래가 완료되면 영수증이 표시되니 잠시만 기다려 주세요.",
    "VoidReceiptTitle": "This Receipt is voided",
    "VoidReceiptSubtitle": "Please contact the merchant for more information.",
    "SharedReceiptText": "공유된 영수증을 조회하기 위해 로그인하세요. ",
    "InvalidHashText": "지금 영수증을 로드할 수 없습니다. 영수증 URL이 올바르지 않습니다. "
  },
  "SaveReceipt": {
    "Description": "영수증이 저장되지 않았습니다. 저장하기 위해 아래를 클릭하세요. ",
    "SaveReceipt": "영수증 저장",
    "SaveInfo": "Piperks에 영수증 저장",
    "UpdatedGoogleWallet": "Saved to Google Wallet",
    "UpdatedSamsungWallet": "Receipt added to Samsung Wallet"
  },
  "PushNotification": {
    "NewReceipt": "푸쉬알림으로 새 영수증을 쉽게 액세스하세요.",
    "Notification": "알림",
    "AllowNotification": "알림을 설정하겠습니까?",
    "Deny": "거부",
    "Allow": "허용",
    "NotificationInfo": "영수증이 도착하면 알려드리겠습니다. "
  },
  "WhatsAppPrompt": {
    "Title": "We are here to help",
    "SubTitle": "문제를 선택하세요:",
    "IssueWithPurchase": "결제 문제",
    "Feedback": "전반적인 피드백",
    "ReceiptError": "영수증 오류",
    "AccountIssue": "계정 문제",
    "ReceiptNumber": "제 영수증 번호는 {receiptNo} 입니다",
    "IssuePurchaseText": "결제건에 문제가 있습니다. ",
    "FeedbackText": "전반적인 피드백이 있습니다. ",
    "ReceiptErrorText": "영수증에 오류가 있습니다. ",
    "AccountIssueText": "계정에 문제가 있습니다. "
  },
  "PWAPrompt": {
    "Description": "Access receipts offline with\none tap install.",
    "Install": "INSTALL"
  },
  "AppUpdatePrompt": {
    "Description": "A newer version of Piperks is available. Please refresh the page or press the button to update it to the newest version.",
    "Title": "Update Available",
    "Button": "UPDATE"
  },
  "MyReceipts": {
    "Title": "나의 영수증",
    "ReceiptLoadingText": "로딩중...",
    "EmptyInfo": "영수증을 추가하면 페이지가 채워질 것입니다. ",
    "EmptyFilter": "영수증을 더 보기 위해 필터 설정을 변경하세요. ",
    "EndOfReceipts": "All receipts have been displayed"
  },
  "SalesReceipt": {
    "HelpText": "도움이 필요하신가요?",
    "WhatsAppButton": "WhatsApp에 메세지를 보내세요. ",
    "FollowUs": "Follow Us On:"
  },
  "ReceiptExport": {
    "ExportingReceiptText": "영수증 내보내는 중",
    "ReceiptExportSuccessText": "영수증은 다운로드에 있습니다."
  },
  "Settings": {
    "ProfileCompleteText": "프로필 작성",
    "AccountInformation": "계정 정보",
    "EnterDetailsText": "더 쉬운 계정 복구를 위해 세부정보를 입력하세요. ",
    "Name": "이름",
    "Edit": "편집",
    "Male": "남성",
    "Phone": "핸드폰번호",
    "Gender": "성별",
    "Dob": "생년월일",
    "Email": "이메일주소",
    "Female": "여성",
    "Other": "이외 ",
    "Indonesia": "인도네시아",
    "Malaysia": "말레이시아",
    "Singapore": "싱가포르",
    "SouthKorea": "한국",
    "Japan": "일본",
    "SetNow": "지금 설정",
    "HomeAddress": "주소",
    "LocationAndLanguage": "지역 및 언어",
    "DisplayLanguage": "원하는 표시 언어를 선택하세요. ",
    "Country": "국가",
    "Language": "언어",
    "LocationAccessTitle": "지역 액세스",
    "LocationAccessDescription": "언어를 자동으로 설정하도록 허용합니다.",
    "Notification": "알림",
    "PushNotification": "푸쉬알림",
    "GetUpdates": "중요한 업데이트를 받으세요. ",
    "ReceiptAlerts": "영수증 알림",
    "NotifiedLatestReceiptsAndUpdates": "최신 영수증 및 업데이트에 대한 알림을 받으세요.",
    "LinkedAccounts": "연결된 계정",
    "EnableLogins": "더 빠른 로그인 위해 활성화",
    "PwaInstallButton": "Piperks 앱 설치",
    "ContactSupportButton": "지원센터 연락처",
    "LogoutButton": "로그 아웃",
    "Version": "버젼",
    "SupportViaWhatsApp": "Whatsapp 지원센터",
    "SupportViaEmail": "이메일 지원센터"
  },
  "Modal": {
    "PushNotif": {
      "Title": "푸쉬알림이 차단되었나요?",
      "Message1": "푸시 알림을 수동으로 활성화하려면 아래를 따르십시오.",
      "Message2": "1. URL 왼쪽에 있는 정보 아이콘을 클릭합니다.",
      "Message3": "2. “알림“ 옆에 있는 “요청“ 또는 “허용“을 선택합니다.",
      "Message4": "3. 페이지를 새로고침하여 업데이트된 설정을 적용합니다."
    },
    "BaseCountry": {
      "Title": "국가",
      "Message1": "계정 페이지에 나열된 국가는 데이터가 보관되는 곳입니다.",
      "Message2": "회원님의 데이터는 현재 '{0}'에 저장되어 있습니다.",
      "Message3": "데이터 저장 위치를 변경하려면 ",
      "Action1": "여기를 클릭하세요"
    }
  },
  "Message": {
    "Subject": "Piperks 앱에 필요한 지원",
    "TypeMessage": "메세지를 입력하세요:",
    "HelpTroubleshoot": "[문제 해결을 위해 이 섹션을 삭제하지 마십시오.]",
    "PhoneModel": "핸드폰 모델: ",
    "PhoneOS": "핸드폰 OS 버전: ",
    "BrowserVersion": "브라우저 버전: ",
    "RegisteredID": "등록된 ID:  ",
    "LatestReceipt": "최근 영수증: "
  },
  "ReceiptDetail": {
    "Store": "Store: ",
    "POS": "POS: ",
    "Cashier": "Cashier: ",
    "TotalSpend": "TOTAL SPEND",
    "PreSettlementTotalSpend": "PROCESSING PAYMENT",
    "YouSave": "YOU SAVED",
    "TotalPaid": "TOTAL PAID",
    "Change": "CHANGE",
    "Tax": "TAX: ",
    "Items": "ITEMS",
    "ItemReturned": "# ITEMS RETURNED ",
    "ItemSold": "# ITEMS SOLD",
    "WifiPassword": "Copy Wifi Password",
    "FreeWifi": "FREE WIFI",
    "PreSettlementTotal": "NOT YOUR FINAL RECEIPT.\n\nFINAL RECEIPT WILL APPEAR ONCE PAYMENT IS\nSUCCESSFUL\n\n"
  },
  "Receipt": {
    "Today": "오늘",
    "Yesterday": "어제",
    "VoidReceiptOverlay": "VOID RECEIPT"
  },
  "DemoError": {
    "title": "이 앱은 데모 버전입니다. ",
    "message": "승인된 데모 URL을 사용하거나 다음에서 요청하십시오."
  },
  "DataPrompt": {
    "Title": "계정 인증",
    "Body": "향후 계정 인증 또는 복구를 위해 영수증을 보호하기 위해 개인 정보를 확인하십시오.",
    "Gender": "성별",
    "YOB": "출생 연도",
    "Submit": "제출",
    "Later": "나중에하기",
    "Select": "선택",
    "DrawerTitle": "복구 세부 정보를 확인하여 영수증을 보호하세요. ",
    "DrawerBody": "세부 정보 확인"
  },
  "Eula": {
    "Title": "사용자 계약"
  },
  "SortFilter": {
    "Title": "정렬 및 필터",
    "SortBy": "정렬 기준",
    "DateAsc": "날짜 (오름차순)",
    "DateDesc": "날짜 (내림차순)",
    "TransactionAsc": "거래 가격 (오름차순)",
    "TransactionDesc": "거래 가격 (내림차순)",
    "DateRange": "날짜 범위",
    "Store": "가게",
    "SeeMore": "더보기",
    "ShowLess": "접기",
    "Apply": "적용하기 ",
    "Reset": "리셋하기",
    "LastWeek": "지난주",
    "LastMonth": "지난달"
  },
  "KoreanExplicit": {
    "Title": "서비스 이용을 위해 약관에 동의해주세요",
    "AcceptAll": "모두 동의합니다",
    "Required": "필수",
    "TermOfUse": "이용약관",
    "PrivacyPolicy": "개인정보 수집 및 이용동의",
    "AgeConsent": "만 14세 이상입니다",
    "Continue": "다음단계",
    "ViewMore": "더보기"
  },
  "ReceiptSharing": {
    "Title": "Receipt Sharing",
    "SubTitle": "Share Link to Anyone",
    "Body": "Receipt sharing feature allows you to share a receipt with others by making it publicly available. When activated, this feature generates a unique receipt sharing link. Anyone who receives this link can use it to view the shared receipt. It's a convenient way to easily share your purchase details or expenses with friends, family, or colleagues.",
    "Irreversible": "irreversible",
    "Invalid": "invalid",
    "ShareLinkExpiry": "Link Expiry Time",
    "Generate": "Generate New Link",
    "GenerateShare": "Generate New Share Link",
    "GenerateBody": "Note: This action is {0}; the previous link will become {1}.",
    "GeneratePrompt": "Click below to generate a new share link.",
    "ShareLink": "Share Receipt Link"
  },
  "EWallet": {
    "PaymentTo": "Payment to",
    "MakePayment": "Make Payment",
    "PaymentProgress": "Payment is in Progress",
    "WaitingPayment": "Please wait a few seconds for processing your payment ...",
    "PaymentCompleted": "Payment Completed!",
    "To": "To"
  },
  "Error": {
    "UnexpectedError": {
      "Title": "예상치 못한 오류",
      "Body": "Sorry, Something went wrong. Click the button below to try again"
    },
    "TryAgain": "잠시 후 다시 시도해 주세요.",
    "BtnTextOK": "OK",
    "BtnTextRetry": "Retry",
    "OtpSendingFailed": {
      "Title": "Failed to send OTP",
      "Body": "Please try again after a few minutes"
    },
    "InvalidPhoneNumber": {
      "Title": "Failed to send OTP",
      "Body": "The phone number you provided is not in the correct format. Please enter your phone number without a country code."
    },
    "IncorrectOtp": {
      "Title": "Incorrect OTP",
      "Body": "Please verify the OTP sent to your registered phone number"
    },
    "SocialLoginFailed": {
      "Title": "{ provider } Login Failed",
      "Body": "Kindly wait a few minutes before retrying"
    },
    "LoginUnsuccessful": {
      "Title": "Login Unsuccessful",
      "Body": "Apologies, an error occurred during your login. Please try again later"
    },
    "UserReceiptsQueryFails": {
      "Title": "Receipt Loading Error",
      "Body": "We're sorry, there was an issue retrieving your receipt. Please try again shortly"
    },
    "GetReceiptError": {
      "Title": "Receipt Retrieval Error",
      "Body": "We're sorry, an unexpected error occurred while fetching your receipt. Please try again shortly"
    },
    "GetReceiptTemplateError": {
      "Title": "Template Retrieval Failed",
      "Body": "We're sorry, an error occurred while fetching the receipt template. Please try again shortly"
    },
    "LinkedToAnotherAccountError": {
      "Title": "Receipt Already Linked",
      "Body": "This receipt is already linked to another account. Reach out to the cashier for more information"
    },
    "LinkReceiptError": {
      "Title": "Receipt Linking Error",
      "Body": "Apologies, we were unable to link the receipt to your account. Please try again soon"
    },
    "ReceiptSubscriptionError": {
      "Title": "Failed to retrieve real-time receipts"
    },
    "AccountUpdateFailed": {
      "Title": "Account Update Failed",
      "Body": "We're sorry, an error occurred while updating your account. Please try again shortly"
    },
    "AccountRetrievalFailed": {
      "Title": "Account Retrieval Failed",
      "Body": "We're sorry, an error occurred while fetching your account data"
    },
    "ServerUnavailable": {
      "Title": "Server Unavailable",
      "Body": "We're currently fixing the issue. Please try again in a few minutes"
    },
    "MissingQueryParam": {
      "Title": "Receipt Not Found",
      "Body": "Looks like something is missing on your receipt link. Please double-check and try again"
    },
    "InvalidReceiptToken": {
      "Title": "Receipt Link Not Found",
      "Body": "We couldn't find the receipt link in our system. Reach out to the cashier for more information."
    },
    "ExpiredReceiptLink": {
      "Title": "Receipt Link Expired",
      "Body": "Looks like the receipt link has expired. Reach out to the cashier for a new receipt link."
    },
    "ExpiredShareReceipt": {
      "Title": "Share Link Has Expired",
      "Body": "The shared receipt link has expired. Please ask the sender for a new link or check the shared receipt’s link."
    },
    "InvalidShareReceipt": {
      "Title": "Share Link Not Available",
      "Body": "The shared receipt link is not available. Please ask the sender for a new link or check the shared receipt’s link."
    }
  },
  "OfflineRenderer": {
    "Title": "Receipt",
    "Text": "No Network, Offline Receipt Displayed",
    "Subtext": "Full receipt details will appear when online",
    "StoreNo": "Store No:",
    "ReceiptNo": "Receipt No:",
    "TotalAmount": "Total Amount",
    "PaymentMethod": "Payment Method"
  }
}
